import { ReducerAction, ReducerHandler } from '../../Types';
import { StoreNavigationHeader } from '../../Types/StoreTypes';
import {
    SET_MOBILE_MENU_OPEN,
    SET_NAVIGATION_IMAGE,
    SET_NAVIGATION_TITLE,
    SET_NAVIGATION_SUBTITLE,
} from '../Actions/navigationHeaderActions';

const initialState = {
    navigationTitle: '',
    navigationSubTitle: '',
    isMobileMenuOpen: false,
    navigationImage: '',
} as StoreNavigationHeader;

const navigationHeaderReducerMap: Record<string, ReducerHandler<StoreNavigationHeader>> = {
    [SET_NAVIGATION_TITLE]: (state, action) => ({ ...state, navigationTitle: action.payload }),
    [SET_NAVIGATION_SUBTITLE]: (state, action) => ({ ...state, navigationSubTitle: action.payload }),
    [SET_MOBILE_MENU_OPEN]: (state, action) => ({ ...state, isMobileMenuOpen: action.payload }),
    [SET_NAVIGATION_IMAGE]: (state, action) => ({ ...state, navigationImage: action.payload }),
};

function navigationHeaderReducer(state = initialState, action: ReducerAction): StoreNavigationHeader {
    const handler = navigationHeaderReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default navigationHeaderReducer;
